import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.css'
})
export class TermsAndConditionsComponent implements OnInit {

  language: string;
  readonly languages: { id: string, text: string }[] = [
    { id: 'en', text: 'English' },
    { id: 'es', text: 'Español' }
  ];

  constructor(
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.language = this.translateService.currentLang || this.languages[0].id;
  }

  onChangeLanguage(event$): void {
      const langId: string = event$.target.value;
      const lang = this.languages.find(i => i.id == langId) || this.languages[0];
      this.translateService.use(lang.id);
      localStorage.setItem('currentLang', lang.id);
  } 
}
